import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  // ---- ACHIEVEMENT ---- //
  ACHIEVEMENT_CREATE_REQUESTING: null,
  ACHIEVEMENT_CREATE_SUCCEEDED: null,
  ACHIEVEMENT_CREATE_ERROR: null,
  ACHIEVEMENT_UPDATE_ERROR: null,
  ACHIEVEMENTS_ALL_REQUESTING: null,
  ACHIEVEMENTS_ALL_RECEIVED: null,
  ACHIEVEMENTS_ALL_ERROR: null,
  // ---- HOMEPAGE ---- //
  ALL_CONTENT_RECEIVED: null,
  ALL_CONTENT_REQUEST_ERROR: null,
  ALL_CONTENT_REQUESTING: null,
  ALL_COURSES_INVALIDATE: null,
  // ---- ALERTS ---- //
  DISMISS_INVITE_TEAM_ALERT: null,
  // ---- LESSONS ---- //
  GET_LESSON_BY_ID_REQUESTING: null,
  GET_LESSON_BY_ID_RECEIVE: null,
  GET_LESSON_BY_ID_ERROR: null,
  GET_LESSONS_BY_ID_RECEIVE: null,
  GET_LESSONS_REQUESTING: null,
  GET_LESSONS_ERROR: null,
  GET_RECOMMENDED_LESSONS_REQUESTING: null,
  GET_RECOMMENDED_LESSONS_RECEIVED: null,
  GET_RECOMMENDED_LESSONS_ERROR: null,
  // --- TRACKS --- //
  TRACK_BY_ID_REQUESTING: null,
  TRACK_BY_ID_RECEIVE: null,
  TRACK_BY_ID_ERROR: null,
  TRACKS_REQUESTING: null,
  TRACKS_RECEIVED: null,
  TRACKS_BY_ID_RECEIVED: null,
  TRACKS_ERROR: null,
  // ---- BOOKMARKS ---- //
  BOOKMARKS_GET_REQUESTING: null,
  BOOKMARKS_GET_RECEIVED: null,
  BOOKMARKS_GET_ERROR: null,
  BOOKMARKS_EDIT_TRACK_REQUESTING: null,
  BOOKMARKS_ADD_TRACK_RECEIVED: null,
  BOOKMARKS_REMOVE_TRACK_RECEIVED: null,
  BOOKMARKS_EDIT_TRACK_ERROR: null,
  BOOKMARKS_EDIT_LESSON_REQUESTING: null,
  BOOKMARKS_ADD_LESSON_RECEIVED: null,
  BOOKMARKS_REMOVE_LESSON_RECEIVED: null,
  BOOKMARKS_EDIT_LESSON_ERROR: null,
  BOOKMARKS_TOGGLE_OPT_IN: null,
  BOOKMARKS_CLEAR_TOOLTIP: null,
  // ---- GETTING_STARTED ---- //
  GETTING_STARTED_GET_REQUESTING: null,
  GETTING_STARTED_GET_RECEIVED: null,
  GETTING_STARTED_GET_ERROR: null,
  GETTING_STARTED_ENROLL_ERROR: null,
  // ---- PUBLIC API ---- //
  PUBLIC_ACHIEVEMENT_REQUESTING: null,
  PUBLIC_ACHIEVEMENT_RECEIVED: null,
  PUBLIC_ACHIEVEMENT_ERROR: null,
  // ---- ACADEMY TO SOFTWARE ---- //
  ACADEMY_TO_SOFTWARE_SET_MODAL_OPEN: null,
  ACADEMY_TO_SOFTWARE_SET_MODAL_CLOSED: null,
  ACADEMY_TO_SOFTWARE_SHOW_TOOLTIP: null,
  ACADEMY_TO_SOFTWARE_HIDE_TOOLTIP: null,
  // ---- ACCOUNTS ---- //
  ACCOUNTS_REQUESTING: null,
  ACCOUNTS_RECEIVED: null,
  ACCOUNTS_ERROR: null,
  // ---- WIZARD ---- //
  WIZARD_SET_PROGRESS_PANEL_EXPANDED: null,
  // ---- PRODUCTS ---- //
  PRODUCTS_REQUESTING: null,
  PRODUCTS_RECEIVED: null,
  PRODUCTS_ERROR: null
});